import {http} from '@utils';

const ABOUT = '关于孩子王'
const TIMELINE = '品牌发展历程'
const ENTER = '欢迎入驻'
const SERVE = '平台服务'
const PARTNER = '合作品牌'

let Anchor = {}
function changeIt(object) {
  function descripterFun(key ,value) {
      return {
          enumerable: true,
          get() {
              return {key,value};
          },
          set(newvalue) {
              value = {key,newvalue};
          }
      }
  }
  for(var i in object){
      Object.defineProperty(object, i, descripterFun(i ,object[i]))
  }
}
Anchor.ENTER = ENTER
Anchor.ABOUT = ABOUT
Anchor.TIMELINE = TIMELINE
Anchor.SERVE = SERVE
Anchor.PARTNER = PARTNER
changeIt(Anchor)

export default {
    namespaced: true,
    state:{
        scrollToId:'',
        Anchor:Anchor,
        cmsHome: {},
    },
    mutations:{
        scrollToId(state,payload) {
            state.scrollToId = payload ;
        },
        setCMSHome(state, data) {
            state.cmsHome = data
        },
        setAnchor(state, data) {
            state.Anchor = data
        },
    },
    actions:{
        enterCheck({ dispatch}){
            dispatch('enterCheck', null, { root: true })
        },
        async getCmsHome({ commit }){
            const res = await http.get('//cms.haiziwang.com/publish/976/newdoor.json');
            const dd = (res && res.data) || {}
            commit('setCMSHome', dd)
            commit('setAnchor', dd.menus)
            return res && res.data
        }
    }
}
